import type { Config } from '.';

export const productionConfig: Config = {
  firebaseConfig: {
    apiKey: 'AIzaSyCTwf2BrvIrt720CTPdGC_AadFFhwDUwRA',
    authDomain: 'matto-production.firebaseapp.com',
    databaseURL: 'https://matto-production.firebaseio.com',
    projectId: 'matto-production',
    storageBucket: 'matto-production.appspot.com',
    messagingSenderId: '960561226925',
    appId: '1:960561226925:web:23d5a96fc58eb894',
    measurementId: 'G-F6ERPNL75J',
  },
  algolia: {
    appId: '3Q86LFIR8V',
    apiKey: '45ec6d4afcecde9c90c9b58802198b35',
  },
  typesense: {
    apiKey: 'OYqd3prJcOwUKQQphlJeiUSltL4Ev5vp',
    url: 'search.matto.com',
  },
};
